/**
 * kult-seminar-reviews.js — Seminar-Bewertungen (sections/kult-seminar-reviews.liquid, [data-sem-reviews]).
 * Kommt jemand über den Link aus der Danke-Mail (?bewerten=1), wird die Section eingeblendet (auch ohne bisherige
 * Bewertungen), angesprungen und das Judge.me-Formular geöffnet, sobald die App das Widget geladen hat.
 */
(function () {
  'use strict';
  var root = document.querySelector('[data-sem-reviews]');
  if (!root || !/[?&]bewerten=1(&|$)/.test(window.location.search)) return;
  root.hidden = false;
  root.scrollIntoView();
  var tries = 0;
  var timer = window.setInterval(function () {
    var link = root.querySelector('.jdgm-write-rev-link');
    var form = root.querySelector('.jdgm-form-wrapper, .jdgm-form');
    var open = form && form.offsetParent !== null;
    if (open || (link && link.offsetParent !== null)) {
      window.clearInterval(timer);
      if (!open) link.click();
      root.scrollIntoView();
      return;
    }
    if (++tries > 40) window.clearInterval(timer);
  }, 250);
})();
